import { enumBillItemProductCode } from '@data-layer/enums/payments';

export class FetchAllBrokers {
  public static readonly type = '[Shared] Fetch All Brokers';
}

export class FetchAllAffiliates {
  public static readonly type = '[Shared] Fetch All Affiliates';
}

export class FetchAllLdsConnections {
  public static readonly type = '[Shared] Fetch All Lds Connections';
}

export class FetchDefaultProducts {
  public static readonly type = '[Shared] Fetch Default Products';
}

export class FetchAllQuotes {
  public static readonly type = '[Shared] Fetch All Quotes';
}

export class FetchAllBillItems {
  public static readonly type = '[Shared] Fetch All Bill Items';
}

export class FetchAllHints {
  public static readonly type = '[Shared] Fetch All Hints';
}

export class FetchAppBetaFlags {
  public static readonly type = '[Shared] Fetch App Beta Flags';
}

export class FetchProductsByCompany {
  public static readonly type = '[Shared] Fetch Products By Company';
  // #13318 — companyId is null on the create-company page (no id yet); the price is then
  // resolved from organizationId, which the backend ignores once a company is given
  constructor(
    public payload: {
      productCode: enumBillItemProductCode;
      companyId: number | null;
      countryId?: number;
      organizationId?: number | null;
    },
  ) {}
}

export class FetchAllDiscountCategories {
  public static readonly type = '[Shared] Fetch All Discount Categories';
}
